import { Avatar, AvatarFallbackText, AvatarImage } from '@vidahealth/vida-ui';

import type { MatchedCoach } from '@/modules/api';

function initialsOf(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('');
}

/** Private to the coach screens — a coach avatar with initials fallback. */
export function CoachAvatar({
  coach,
  size = 'lg',
}: {
  coach: Pick<MatchedCoach, 'displayName' | 'image'>;
  size?: 'lg' | 'xl';
}) {
  return (
    <Avatar size={size}>
      <AvatarFallbackText>{initialsOf(coach.displayName)}</AvatarFallbackText>
      {coach.image ? <AvatarImage source={{ uri: coach.image }} alt={coach.displayName} /> : null}
    </Avatar>
  );
}
